export function getEclLabel(ecl: string) {
    const statusLabels: Partial<Record<string, string>> = {
        ecl4: 'ECL 4',
        ecl3: 'ECL 3',
        ecl2: 'ECL 2',
        ecl1: 'ECL 1',
        noEcl: 'No ECL',
    };

    return statusLabels[ecl] ?? ecl;
}
